import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import SidebarItem from "./SidebarItem";

class Sidebar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeItem: 0,
            hoveredItem: 0
        };
    }

    toggleActive = (i) => {
        this.props.setActiveSection(i);
        this.setState({activeItem: i});
    };

    getItems = () => {
        let items = [];

        this.props.items.forEach((item, i) => {
            items.push(
                <SidebarItem
                    key={i}
                    text={item}
                    active={this.state.activeItem === item}
                    toggleActive={() => this.toggleActive(item)}
                />
            );
        });
        return items;
    };

    componentDidMount() {
        if (this.props.activeItem != null && this.props.items)
            this.setState({activeItem: this.props.activeItem});
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.items || (!prevProps.items.length && prevProps.items !== this.props.items)) {
            this.setState({activeItem: this.props.items[1]})
        }
    }

    render() {
        return (
            <div className="col-3">
                <div
                    className="nav flex-column nav-tabs card-header-tabs justify-content-stretch"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                >
                    {this.getItems()}
                </div>
            </div>
        );
    }
}

Sidebar.propTypes = {
    items: PropTypes.array.isRequired,
    setActiveSection: PropTypes.func.isRequired,
    activeItem: PropTypes.number
};

export default Sidebar;
